import React from "react"

import { Control } from "react-hook-form"

import RatingSelect from "./RatingSelect"
import SectionHeader from "./SectionHeader"

interface TimeManagementSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  calculateResult: () => void
}

const timeManagementOptions = [
  { value: "Ahead", label: "Ahead - Completed early without compromising quality" },
  { value: "Up to Standard", label: "Up to Standard - On time, within expected window" },
  { value: "Needs Improvement", label: "Needs Improvement - Minor delays, some inefficiencies" },
  { value: "Behind", label: "Behind - Significant delays or poor route pacing" },
]

const TimeManagementSection: React.FC<TimeManagementSectionProps> = ({
  control,
  calculateResult,
}) => {
  return (
    <div className="space-y-4">
      <SectionHeader title="Time Management" />

      <RatingSelect
        control={control}
        name="timeManagement"
        label="Efficiency and adherence to expected route duration"
        options={timeManagementOptions}
        calculateResult={calculateResult}
      />
    </div>
  )
}

export default TimeManagementSection
